import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

//import GooglePanel from '../components/map/GooglePanel';

import AssetViewControl from '../components/assetView/AssetViewControl';
import AssetList from '../components/assetView/AssetList';
import AssetSummaryList from '../components/assetView/AssetSummaryList';
import AssetFooter from '../components/assetView/AssetFooter';
import EventFooter from '../components/vehicleEvents/EventFooter';
import AssetEventsViewModal from '../components/vehicleEvents/AssetEventsViewModal';

import { liveTrackinglayoutSelector } from '../features/layout/layoutSlice';
import { detailViewSelector, assetViewTypeSelector } from '../features/assets/assetsSlice';
import { eventViewTypeSelector } from '../features/events/eventsSlice';
import { setMapControl } from '../features/map/mapSlice';

export default function LiveTracking() {

    const dimentions = useSelector(liveTrackinglayoutSelector);
    const dispatch = useDispatch();
    const viewType = useSelector(assetViewTypeSelector);
    const detailView = useSelector(detailViewSelector);
    const eventViewType = useSelector(eventViewTypeSelector);


    useEffect(() => {
        dispatch(setMapControl('asset'));
    }, [dispatch]);

    return (
        <div>

            <div>
                <AssetViewControl

                />
            </div>
            <div>
                {
                    viewType === 'fullList' || viewType === 'filteredList'
                        ? <AssetList />
                        : viewType === 'summary'
                            ? <AssetSummaryList />
                            : null
                }
            </div>
            <div style={dimentions.footer}>
                {
                    detailView ? <AssetFooter /> : <EventFooter />
                }
            </div>
            <div>
                {
                    detailView && eventViewType === 'oneAsset' && <AssetEventsViewModal assetId={detailView} />
                }
            </div>

        </div>
    );
}
